// import "./style.css";

import { Badge } from "react-bootstrap";

export const tableData = (data) => {
  const columns = [
    {
      field: "hora",
      headerName: "Hora",
      // headerClassName: "custom-header",
      minWidth: 80,
      flex: 1,
      sortable: false,
    },
    {
      field: "numero_acta",
      headerName: "N° Acta",
      minWidth: 80,
      flex: 1,
      sortable: false,
    },
    {
      field: "",
      headerName: "Interacción",
      // headerClassName: "custom-header",
      minWidth: 100,
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        return params.row.estado_id != 12 ? (
          <Badge bg="success">Aprobada</Badge>
        ) : (
          <Badge bg="danger">Desaprobada</Badge>
        );
      },
      // renderHeader: () => {
      //   return (
      //     <div className="d-flex w-100 justify-content-center mx-auto">
      //       <HeaderColumn
      //         label={"Fecha"}
      //         color={"#FFF"}
      //         setFiltersField={setFiltersField}
      //         setOrder={setOrder}
      //         setOrderField={setOrderField}
      //         typeInput={"date"}
      //         field={"fecha_hora"}
      //         place={"Fecha"}
      //       />
      //     </div>
      //   );
      // },
    },
    {
      // field: "actions",
      // headerName: "Ver",
      // minWidth: 100,
      // flex: 1,
      // sortable: false,
      // headerClassName: "headerActions",

      // renderCell: (params) => {
      //   return (
      //     <AccionesActaTable
      //       id={params.row.id}
      //       estado_id={params.row.estado_id}
      //       alertas={params.row.alertas}
      //       actaFisica={params.row.get_acta_fisica}
      //       acta={params.row}
      //       setActaAImprimir={setActaAImprimir}
      //       user_id_asignado={params.row.user_id_asignado}
      //       estado={estado_id}
      //       setActaADesasignar={setActaADesasignar}
      //     />
      //   );
      // },
    },
  ];

  const rows =
    data?.map((d, index) => {
      return {
        id: index,
        hora: d?.hora,
        numero_acta: d?.numero_acta,
        estado_id: d?.estado,
      };
    }) || [];

  const filter = (d, value) => {
    value = value.toLowerCase();

    return (
      String(d.id)?.toString().toLowerCase().includes(value) ||
      String(d.plate)?.toString().toLowerCase().includes(value) ||
      String(d.fecha_hora)?.toString().toLowerCase().includes(value) ||
      String(d.infraccion)?.toString().toLowerCase().includes(value)
    );
  };

  return { columns, rows, filter };
};
